export enum DonationPositionUsed {
  LeftLateral = 'LeftLateral',
  RightLateral = 'RightLateral',
  Sitting = 'Sitting',
  Standing = 'Standing',
  Sternal = 'Sternal',
  NotApplicable = 'NotApplicable',
}
